var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 0L21.3602 3.58059L26.9923 3.24671L28.4152 8.70635L33.168 11.7467L31.11 17L33.168 22.2533L28.4152 25.2936L26.9923 30.7533L21.3602 30.4194L17 34L12.6398 30.4194L7.00765 30.7533L5.58477 25.2936L0.832039 22.2533L2.89 17L0.832039 11.7467L5.58477 8.70635L7.00765 3.24671L12.6398 3.58059L17 0Z",
    fill: "#477BE7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1113 23.9275L17.9884 23.9275L23.9261 8.81643L21.0491 8.81641L15.1113 23.9275Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6293 23.9256L15.0601 23.9256L11.333 13.8516L13.9022 13.8516L17.6293 23.9256Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckMark);
export default __webpack_public_path__ + "static/media/check_mark.16e7762c84e11f378b805b285d75a1ba.svg";
export { ForwardRef as ReactComponent };